import { criarParticipante } from '@/uteis/action/tramite/participante'

export const criarDestino = (sessao) => {
  var destino = criarParticipante(sessao.descricaoDepartamento, sessao.idDepartamento, 'ID', sessao.siglaDepartamento)
  destino.participantePai = criarParticipante(sessao.descricaoOrgao, sessao.idOrgao, 'ID', sessao.siglaOrgao)
  return destino
}
